import { render, staticRenderFns } from "./userauthorityset_test.vue?vue&type=template&id=06724c6b&scoped=true&"
import script from "./userauthorityset_test.vue?vue&type=script&lang=js&"
export * from "./userauthorityset_test.vue?vue&type=script&lang=js&"
import style0 from "./userauthorityset_test.vue?vue&type=style&index=0&id=06724c6b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06724c6b",
  null
  
)

export default component.exports